import { Component } from '@angular/core';

@Component({
  selector: 'app-sm-reviews',
  templateUrl: './sm-reviews.component.html',
  styleUrls: ['./sm-reviews.component.css']
})
export class SmReviewsComponent {

  shownReviews = [
    {
      customer_location: "Chennai, Tamil Nadu",
      customer_name: "Ranjhit Kumar",
      description_social_test: "Bajaj Capital is my piggy bank, which owns 5 decades of trust within many individuals, that tell us how, when and where to invest in Multiple Products to create Wealth and Prosperity and more importantly without misleading us and giving us need base services. Choose Bajaj Capital for Happy and Safe life.",
      field_customer_image: "https://image.bajajcapitalone.com/bajajcapital/Mr.%20Ranjith%20Kumar.png",
      field_social_icon: "https://image.bajajcapitalone.com/bajajcapital/facebook-logo.png",
      social_rating: "5",
    },
    {
      customer_location: "Kolkata",
      customer_name: "Rahul Jha",
      description_social_test: "I have been a customer of Bajaj Capital since last 2 yrs. They helped me to understand systematic investment planning by diversifying my portfolio and asset allocation which is very much needed for this tough time we have seen in the last 3 to 4 months. I am very thankful to the team of Bajaj Capital, they are helpful in providing financial planning and guidance. Congratulations to the whole Bajaj Capital Team and Thank you once again.",
      field_customer_image: "https://image.bajajcapitalone.com/bajajcapital/Mr.%20Rahul%20Jha.png",
      field_social_icon: "https://image.bajajcapitalone.com/bajajcapital/twitter-logo.png",
      social_rating: "4"
    },
    {
      customer_location: "Rohini, Delhi",
      customer_name: "Vikas Sharma",
      description_social_test: "Good Morning, mera naam Vikas Sharma hai aur main Rohini main rehta hun, Bajaj Capital ke saath mere ko lag bhag 3 saal hogayen hain, Aacha mera experience raha hai inke saath, kahin kuch query hoti hai kahin kuch kaam delay ho raha hai, pending ho, 24*7 support milta hai, Main definitely isko recommend karunga.",
      field_customer_image: "https://image.bajajcapitalone.com/bajajcapital/Mr.%20Vikash%20Sharma.png",
      field_social_icon: "https://image.bajajcapitalone.com/bajajcapital/facebook-logo_0.png",
      social_rating: "3.5"
    },
    {
      customer_location: "Pune, Maharashtra",
      customer_name: "Vikram Ainchwar",
      description_social_test: "Bajaj Capital has helped me in investing since 2012, in every sector, maybe Mutual Fund, NFO. I like their service, they think in details, provide more info as needed and solve all your queries, not necessarily what they are suggesting we need to invest but you can think with information they have provided and you can go. I have believed in them since 2012, and also suggested few of my friends.\r\nThank You.\r\n",
      field_customer_image: "https://image.bajajcapitalone.com/bajajcapital/Mr.%20Vikram_twitter.png",
      field_social_icon: "https://image.bajajcapitalone.com/bajajcapital/twitter-logo_1.png",
      social_rating: "4.5"
    },
    {
      customer_location: "India",
      customer_name: "Mayank Kukreja",
      description_social_test: "I have been Associated with Bajaj capital from the past 5 years and results have been really good. My relationship manager Rohit Semwal has always helped me in getting my investments to the maximum level.",
      field_customer_image: "https://image.bajajcapitalone.com/bajajcapital/Customer%20Testimonial.png",
      field_social_icon: "https://image.bajajcapitalone.com/bajajcapital/facebook-logo_1.png",
      social_rating: "5"
    }
  ]

}
